import { render } from "./MenuNode.vue?vue&type=template&id=125e9d3e"
import script from "./MenuNode.vue?vue&type=script&lang=js"
export * from "./MenuNode.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__